import type { Board } from '@/types/board';
import type { TeamMember } from '@/types/team';

export interface AssigneeOption {
  id: number;
  name: string;
}

/**
 * Responsáveis possíveis numa atividade (mesma regra do backend, docs/API.md "Regras"):
 *  - quem o usuário pode delegar (`assignable`: admin → todos; gestor → ele + subordinados;
 *    analista → ele mesmo);
 *  - num quadro compartilhado (evento/projeto), também os membros do quadro;
 *  - o responsável atual, mesmo fora das listas, para a seleção não "sumir" ao editar.
 */
export const buildAssigneeOptions = (
  assignable: Pick<TeamMember, 'id' | 'name'>[],
  board?: Pick<Board, 'board_type' | 'members'> | null,
  current?: { id?: number | null; name?: string | null },
): AssigneeOption[] => {
  const map = new Map<number, string>();
  for (const m of assignable) map.set(m.id, m.name);
  if (board && board.board_type !== 'daily') {
    for (const m of board.members ?? []) {
      if (!map.has(m.team_member_id)) map.set(m.team_member_id, m.name);
    }
  }
  if (current?.id && !map.has(current.id)) map.set(current.id, current.name || `#${current.id}`);
  return [...map.entries()]
    .map(([id, name]) => ({ id, name }))
    .sort((a, b) => a.name.localeCompare(b.name, 'pt-BR'));
};
